import { createAction } from 'redux-actions';
import { EveryPortAdditionalServices, EveryPortSelectedServices } from './reducers';
import {
	NASProductFragment,
	NASProductFareFragment,
	NASProductCategory,
	NASSelectedProductFragment
} from '@websky/graphql';

export const SET_EVERY_PORT_ACTION = 'SET_EVERY_PORT_ACTION';
export const SET_ALL_EVERY_PORT_ACTION = 'SET_ALL_EVERY_PORT_ACTION';

export interface SetEveryPortService {
	product: NASProductFragment;
	additionalServices: EveryPortAdditionalServices[];
	travellerIds?: string[];
	fare: NASProductFareFragment;
	orders: NASSelectedProductFragment['orders'];
}

export interface SetEveryPortServicePayload {
	services: SetEveryPortService[];
	category: NASProductCategory;
}

export const setEveryPortServiceAction = createAction<SetEveryPortServicePayload>(SET_EVERY_PORT_ACTION);
export const setAllEveryPortAction = createAction<EveryPortSelectedServices>(SET_ALL_EVERY_PORT_ACTION);
